(function() {

    function addSubscribeChangedFunction() {
        ko.subscribable.fn.subscribeChanged = function(callback) {
            var oldValue;
            this.subscribe(function(_oldValue) {
                oldValue = _oldValue;
            }, this, 'beforeChange');

            this.subscribe(function(newValue) {
                callback(newValue, oldValue);
            });
        };
    }

    function overrideValueBindingHandler() {
        // override for KO's default 'value' binding
        var init = ko.bindingHandlers['value'].init;

        ko.bindingHandlers['value'].init = function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var allBindings = allBindingsAccessor();
            allBindings.valueUpdate = ["change", "afterkeydown"];
            var throttleDuration = allBindings.throttle || 1000;
            init(element, valueAccessor, allBindingsAccessor);

            var data = jQuery.hasData(element) && jQuery._data(element);

            $.each(data.events, function (i, event) {
                $.each(event, function (i, handler) {
                    if (handler.type == "keydown") {
                        var x = handler['handler']; 
                        handler['handler'] = _.debounce(x, throttleDuration);
                    }
                });
            });
        };
    }

    function addAnimateSlideBindingHandler() {
        ko.bindingHandlers["animate_slide"] = {
            init: function(element, valueAccessor) {
                var value = valueAccessor();
                $(element).toggle(value());
            },
            update: function(element, valueAccessor) {
                var value = valueAccessor();
                value() ? $(element).slideDown(200) : $(element).slideUp(200);
            }
        };
    }

    addSubscribeChangedFunction();
    overrideValueBindingHandler();
    addAnimateSlideBindingHandler();
})();
define("fileplankoex", function(){});

